import { ArrowUpRight } from "lucide-react";
import ScrollReveal from "../ScrollReveal";
import { CALENDLY_URL } from "../../data/content";

export const CTASection = () => {
  return (
    <section
      data-testid="cta-section"
      className="relative py-24 md:py-36 border-t border-white/10 overflow-hidden"
    >
      {/* Large outline text behind */}
      <div
        className="absolute inset-0 flex items-center justify-center pointer-events-none select-none"
        aria-hidden
      >
        <div className="font-display text-[22vw] md:text-[14vw] font-black tracking-tighter text-outline-violet whitespace-nowrap">
          OBSIDIAN
        </div>
      </div>

      <div className="relative max-w-4xl mx-auto px-6 md:px-10 text-center">
        <ScrollReveal>
          <div className="text-xs uppercase tracking-[0.4em] text-white/40 mb-6">
            / Let's build
          </div>
          <h2 className="font-display text-4xl md:text-6xl lg:text-7xl font-black uppercase tracking-tighter leading-[0.95]">
            Your brand,<br />carved in obsidian.
          </h2>
          <p className="mt-6 text-white/60 max-w-xl mx-auto text-base md:text-lg leading-relaxed">
            Book a 30-min Zoom call. We'll diagnose your brand, scope a sharp
            plan and ship it in days — not months.
          </p>
          <div className="mt-10 flex flex-wrap justify-center items-center gap-4">
            <a
              href={CALENDLY_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="cta-book-call-button"
              className="shine-box group inline-flex items-center gap-3 btn-violet px-7 py-4 text-xs md:text-sm uppercase tracking-[0.3em] font-semibold"
            >
              Book a Zoom Call
              <ArrowUpRight size={16} />
            </a>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
};

export default CTASection;
